module.exports = __webpack_public_path__ + "static/media/2DGACM4.e9c34b23.jpg";